const testingConstants = {
  leaveRoomOption: 'leaveRoomOption',
  editRoomOption: 'editRoomOption',
  changeMatrixHomeserverButton: 'changeMatrixHomeserverButton',
  matrixHomeserverInput: 'matrixHomeserverInput',
  matrixHomeserverDisplay: 'matrixHomeserverDisplay',
  setHomeserverButton: 'setHomeserverButton',
  profileOption: 'profileOption',
  settingsOption: 'settingsOption',
  logoutOption: 'logoutOption',
  signInOption: 'signInOption',
  roomListItem: 'roomListItem',
  leaveRoomButton: 'leaveRoomButton',
  meetingChatSidebarLoading: 'meetingChatSidebarLoading',
  chatLoaded: 'chatLoaded',
  chatInitializationError: 'chatInitializationError',
  feedbackForm: 'feedbackForm',
  joinBtn: 'joinBtn',
  tosCheckbox: 'tosCheckbox',
  createRoomButton: 'createRoomButton',
  joinRoomButton: 'joinRoomButton',
  joinRoomIdInput: 'joinRoomIdInput',
  kickButton: 'kickButton',
  banButton: 'banButton',
  roomTitle: 'roomTitle',
  roomAlias: 'roomAlias',
  waitingListToggle: 'waitingListToggle',
  scheduledToggle: 'scheduledToggle',
  startDateInput: 'startDateInput',
  startTimeInput: 'startTimeInput',
  dateInput: 'dateInput',
  timeInput: 'timeInput',
  descriptionInput: 'descriptionInput',
  chatInput: 'chatInput',
  sendChatMessageButton: 'sendChatMessageButton',
  messageSender: 'messageSender',
  chatMessage: 'chatMessage',
  openChatButton: 'openChatButton',
  endCallPopupCloseBtn: 'endCallPopupCloseBtn',
  backToMainPageButton: 'backToMainPageButton',
  leaveMeeting: 'leaveMeeting',
  copyButton: 'copyButton',
  copyButtonIcon: 'copyButtonIcon',
  matrixIdCopyButton: 'matrixIdCopyButton',
  joinEnterName: 'joinEnterName',
  openSidebarButton: 'openSidebarButton',
  raiseHandToastClose: 'raiseHandToastClose',
  raiseHandIndicator: 'raiseHandIndicator',
  createRoomModal: 'createRoomModal',
  submitFormButton: 'submitFormButton',
  raiseHandButton: 'raiseHandButton',
  hangUpButton: 'hangUpButton',
  peopleSidebarButton: 'peopleSidebarButton',
  peopleSidebar: 'peopleSidebar',
  confirmKick: 'confirmKick',
  confirmBan: 'confirmBan',
  raiseHandToast: 'raiseHandToast',
  toastCloseButton: 'toastCloseButton',
  audioInputChangedToast: 'device_toast_audioinput',
  videoInputChangedToast: 'device_toast_videoinput',
  profileNameUpdatedToast: 'profileNameUpdated',
  optionsDropdown: 'optionsDropdown',
  continueWithoutDevices: 'continueWithoutDevices',
  addParticipantsModal: 'addParticipantsModal',
  autoRemindersModal: 'autoRemindersModal',
  reviewRoomStepModal: 'reviewRoomStepModal',
  breakoutRoomButton: 'breakoutRoomButton',
  breakoutRoomsSidebar: 'breakoutRoomsSidebar',
  assignAuto: 'assignAuto',
  assignManual: 'assignManual',
  assignSelf: 'assignSelf',
  breakoutRoomsTimeLimitToggle: 'breakoutRoomsTimeLimitToggle',
  createBreakoutRooms: 'createBreakoutRooms',
  startBreakoutRooms: 'startBreakoutRooms',
  breakoutRoom: 'breakoutRoom',
  mainRoom: 'mainRoom',
  returnToMainRoom: 'returnToMainRoom',
  breakoutRoomsStartedToast: 'breakoutRoomsStartedToast',
  calendarViewToggle: 'calendarViewToggle',
  continueAsGuest: 'continueAsGuest',
  profileBtn: 'profileBtn',
  dropdownOption: 'dropdownOption',
  dropdownSelectedIndicator: 'dropdownSelectedIndicator',
  authStartButton: 'authStartButton',
  toggleAudioButton: 'toggleAudioButton',
  changeMicrophone: 'changeMicrophone',
  changeCamera: 'changeCamera',
  startScreenShare: 'startScreenShare',
  emptyRoomListView: 'emptyRoomListView',
  cancelFormButton: 'cancelFormButton',
  generatedNumbers: 'generatedNumbers',
  calendarContainer: 'calendarContainer',
  toggleVideoButton: 'toggleVideoButton',
  stopScreenShareButton: 'stopScreenShareButton',
  stopScreenSharePopup: 'stopScreenSharePopup',
  stopScreenShareConfirm: 'stopScreenShareConfirm',
  screenTilesVisibilityToggle: 'screenTilesVisibilityToggle',
  avatar: 'avatar',
  previewVideo: 'previewVideo',
  microphoneOffIndicator: 'microphoneOffIndicator',
  cameraOffIndicator: 'cameraOffIndicator',
  confirmPopupButton: 'confirmPopupButton',
  discardConfirmationCancelButton: 'discardConfirmationCancelButton',
  discardConfirmationDiscardButton: 'discardConfirmationDiscardButton',
  roomListToggle: 'roomListToggle',
  meedioLogo: 'meedioLogo',
  homeserverUrlError: 'homeserverUrlError',
  roomsListItemJoinButton: 'roomsListItemJoinButton',
  roomsListItemShareButton: 'roomsListItemShareButton',
  shareRoomButton: 'shareRoomButton',
  shareRoomDirectLinkOption: 'shareRoomDirectLinkOption',
  shareRoomDirectLink: 'shareRoomDirectLink',
  closeModalButton: 'closeModalButton',
  noResultsView: 'noResultsView',
  reactionsButton: 'reactionsButton',
  noPermissionsModal: 'noPermissionsModal',
  noPermissionsModalDismissButton: 'noPermissionsModalDismissButton',
  profileNameInput: 'profileNameInput',
  updateProfileNameButton: 'updateProfileNameButton',
  unverifiedChatLockOverlay: 'unverifiedChatLockOverlay',
  unverifiedChatLockTitle: 'unverifiedChatLockTitle',
  unverifiedChatLockVerifyButton: 'unverifiedChatLockVerifyButton',
  messengerContentChatBody: 'messengerContentChatBody',
  participantsTab: 'participantsTab',
  joinError: 'joinError',
  participantFrame: 'participant-frame',
  participantVideo: 'participant-video',
  changeSecurityCodeModal: 'changeSecurityCodeModal',
  changeSecurityCodeCurrentInput: 'changeSecurityCodeCurrentInput',
  changeSecurityCodeConfirmBtn: 'changeSecurityCodeConfirmBtn',
  whiteboardButton: 'whiteboard-button',
  whiteboardTile: 'whiteboard-tile',
  whiteboardIframe: 'whiteboard-iframe',
  unlockWithSecurityCodeModal: 'unlockWithSecurityCodeModal',
  unlockWithSecurityCodeInput: 'unlockWithSecurityCodeInput',
  unlockWithSecurityCodeConfirmBtn: 'unlockWithSecurityCodeConfirmBtn',
  loginSecretStorageUnlockGate: 'loginSecretStorageUnlockGate',
  loginSecretStorageUnlockInput: 'loginSecretStorageUnlockInput',
  loginSecretStorageUnlockConfirmBtn: 'loginSecretStorageUnlockConfirmBtn',
  jumpToLatestButton: 'jumpToLatestButton',
  jumpToUnreadButton: 'jumpToUnreadButton',
  chatTimelineSeparator: 'chatTimelineSeparator',
  chatTimelineSeparatorPill: 'chatTimelineSeparatorPill',
  messageStatus: 'messageStatus',
  messageStatusSendAgain: 'messageStatusSendAgain',
  resetKeysModal: 'reset-keys-modal',
  resetAccountBtn: 'reset-account-btn',
  resetContinueBtn: 'reset-continue-btn',
  resetNotNowBtn: 'reset-not-now-btn',
  resetConsequencesList: 'reset-consequences-list',
  emojiPickerButton: 'emojiPickerButton',
  emojiPickerPopover: 'emojiPickerPopover',
  messageActionsBar: 'messageActionsBar',
  messageContextMenuButton: 'messageContextMenuButton',
  messageContextMenu: 'messageContextMenu',
  reactionBadge: 'reactionBadge',
  typingIndicator: 'typingIndicator',
  typingAvatar: 'typingAvatar',
  typingDots: 'typingDots',
  searchPanel: 'searchPanel',
  searchInput: 'searchInput',
  searchResult: 'searchResult',
  searchEmptyState: 'searchEmptyState',
  searchResultLocatingSpinner: 'searchResultLocatingSpinner',
  conversationListItem: 'conversationListItem',
  pushNotificationsToggle: 'pushNotificationsToggle',
  replyBanner: 'reply-banner',
  replySnippet: 'reply-snippet',
  notificationsTab: 'notificationsTab',
  notificationsTabSoundToggle: 'notificationsTabSoundToggle',
  notificationOnboardingCard: 'notificationOnboardingCard',
  notificationOnboardingEnableSound: 'notificationOnboardingEnableSound',
  notificationOnboardingDismiss: 'notificationOnboardingDismiss',
  messengerSidebarMuteSoundToggle: 'messengerSidebarMuteSoundToggle',
  messageBubble: 'messageBubble',
  mobileMessageSheet: 'mobileMessageSheet',
  conversationHeaderInfoButton: 'conversationHeaderInfoButton',
  sidebarMenuMeetings: 'sidebarMenuMeetings',
  scheduleMeetingButton: 'scheduleMeetingButton',
  meetingsSidebarCreateStart: 'meetingsSidebarCreateStart',
  meetingsSidebarCreateSchedule: 'meetingsSidebarCreateSchedule',
  scheduleMeetingModal: 'scheduleMeetingModal',
  scheduleMeetingTitleInput: 'scheduleMeetingTitleInput',
  scheduleMeetingDescriptionInput: 'scheduleMeetingDescriptionInput',
  scheduleMeetingSubmitButton: 'scheduleMeetingSubmitButton',
  scheduleMeetingCancelButton: 'scheduleMeetingCancelButton',
  meetingsSidebarIncomingTab: 'meetingsSidebarIncomingTab',
  meetingsSidebarPastTab: 'meetingsSidebarPastTab',
  meetingsSidebarCard: 'meetingsSidebarCard',
  meetingsSidebarCardMenu: 'meetingsSidebarCardMenu',
  meetingsSidebarCardMenuView: 'meetingsSidebarCardMenuView',
  meetingsSidebarCardMenuEdit: 'meetingsSidebarCardMenuEdit',
  meetingsSidebarCardMenuCancel: 'meetingsSidebarCardMenuCancel',
  meetingsSidebarActiveJoin: 'meetingsSidebarActiveJoin',
  meetingsSidebarActiveMenu: 'meetingsSidebarActiveMenu',
  meetingsSidebarActiveEndMeeting: 'meetingsSidebarActiveEndMeeting',
  meetingsSidebarPastEntry: 'meetingsSidebarPastEntry',
  meetingsSidebarPastMenu: 'meetingsSidebarPastMenu',
  activeMeetingBanner: 'active-meeting-banner',
  activeMeetingBannerJoin: 'activeMeetingBannerJoin',
  activeMeetingBannerClose: 'activeMeetingBannerClose',
  activeMeetingBannerParticipants: 'activeMeetingBannerParticipants',
  activeMeetingBannerEnd: 'activeMeetingBannerEnd',
  activeMeetingBannerSlider: 'activeMeetingBannerSlider',
  activeMeetingBannerSliderNext: 'activeMeetingBannerSliderNext',
  activeMeetingBannerSliderPrev: 'activeMeetingBannerSliderPrev',
  scheduledRoomJoinForm: 'scheduledRoomJoinForm',
  scheduledMeetingTimeBlock: 'scheduledMeetingTimeBlock',
  preMeetingStatusCard: 'preMeetingStatusCard',
  cancelMeetingConfirmButton: 'cancelMeetingConfirmButton',
  cancelMeetingDismissButton: 'cancelMeetingDismissButton',
  syncScreenButton: 'syncScreenButton',
  startSyncConfirmationButton: 'startSyncConfirmationButton',
  ongoingCallsSection: 'ongoing-calls-section',
  videoCallDetails: 'videoCallDetails',
  videoCallDetailsInviteLink: 'videoCallDetailsInviteLink',
  videoCallDetailsDescription: 'videoCallDetailsDescription',
  videoCallDetailsGroupChat: 'videoCallDetailsGroupChat',
  videoCallDetailsOpenCalendar: 'videoCallDetailsOpenCalendar',
  videoCallDetailsCancel: 'videoCallDetailsCancel',
  videoParticipantPanel: 'videoParticipantPanel',
  videoParticipantInviteButton: 'videoParticipantInviteButton',
  videoParticipantListItem: 'videoParticipantListItem',
  videoMemberDetails: 'videoMemberDetails',
  videoParticipantSearch: 'videoParticipantSearch',
  videoParticipantNoResults: 'videoParticipantNoResults',
  videoParticipantEmptyState: 'videoParticipantEmptyState',
  videoCallDetailsParticipantsPlaceholder: 'videoCallDetailsParticipantsPlaceholder',
  videoHubInlineEditForm: 'videoHubInlineEditForm',
  videoHubInlineEditSave: 'videoHubInlineEditSave',
  videoHubInlineEditCancel: 'videoHubInlineEditCancel',
  videoHubInlineEditNameField: 'videoHubInlineEditNameField',
  videoHubInlineEditSlugField: 'videoHubInlineEditSlugField',
  videoHubInlineEditDescriptionField: 'videoHubInlineEditDescriptionField',
  videoHubInlineEditOrgToggle: 'videoHubInlineEditOrgToggle',
  videoHubInlineEditPrivateToggle: 'videoHubInlineEditPrivateToggle',
  videoHubInlineEditWaitingListToggle: 'videoHubInlineEditWaitingListToggle',
  securityCodeListBanner: 'securityCodeListBanner',
  securityCodeListBannerCta: 'securityCodeListBannerCta',
  securityCodeListBannerDismiss: 'securityCodeListBannerDismiss',
  meetingDetailMobileTabs: 'meeting-detail-mobile-tabs',
  videoSessionTimeline: 'video-session-timeline',
  videoSessionTimelineDateInput: 'video-session-timeline-date',
  videoSessionTimelineCard: 'video-session-timeline-card',
  videoSessionTimelineEmpty: 'video-session-timeline-empty',
  videoSessionTimelineDateClear: 'video-session-timeline-date-clear',
  workspaceSettingsApiKeysTab: 'workspaceSettingsApiKeysTab',
  apiKeysCreateButton: 'apiKeysCreateButton',
  apiKeysActiveTab: 'apiKeysActiveTab',
  apiKeysExpiredTab: 'apiKeysExpiredTab',
  apiKeysDocumentationButton: 'apiKeysDocumentationButton',
  apiKeyCopyButton: 'apiKeyCopyButton',
  apiKeysNoAccess: 'apiKeysNoAccess',
  apiKeysDisabled: 'apiKeysDisabled',
  apiKeysEmptyState: 'apiKeysEmptyState',
  apiKeysListPanel: 'apiKeysListPanel',
  apiKeysLoadingSkeleton: 'apiKeysLoadingSkeleton',
  apiKeyCreatedModal: 'apiKeyCreatedModal',
  apiKeyCreatedSecret: 'apiKeyCreatedSecret',
  apiKeyCreatedCopyButton: 'apiKeyCreatedCopyButton',
  apiKeyCreatedFinishButton: 'apiKeyCreatedFinishButton',
  apiKeyActionErrorModal: 'apiKeyActionErrorModal',
  apiKeyActionErrorRetryButton: 'apiKeyActionErrorRetryButton',
  generateApiKeyModal: 'generateApiKeyModal',
  generateApiKeyNameInput: 'generateApiKeyNameInput',
  generateApiKeyScopeCheckbox: 'generateApiKeyScopeCheckbox',
  generateApiKeyExpirationSelect: 'generateApiKeyExpirationSelect',
  generateApiKeySubmitButton: 'generateApiKeySubmitButton',
  generateApiKeyCancelButton: 'generateApiKeyCancelButton',
  rotateApiKeyModal: 'rotateApiKeyModal',
  rotateApiKeyExpirationSelect: 'rotateApiKeyExpirationSelect',
  rotateApiKeySubmitButton: 'rotateApiKeySubmitButton',
  apiKeyRowMenuRotate: 'apiKeyRowMenuRotate',
  apiKeyRowMenuRevoke: 'apiKeyRowMenuRevoke',
};

export default testingConstants;
